/**
 * Set query parameters on an app-relative path without string concatenation.
 *
 * Callers must never append `?x=` / `&x=` by hand: whether a path already
 * carries a query is not knowable at the call site (a blocked campaign item
 * once rendered `/campaigns/<id>&filter=all` — a route that does not exist).
 * Existing params are kept, the given ones are set (replacing any prior value),
 * `null`/`undefined` removes a param, and any `#hash` is preserved.
 */
export function withQueryParams(path: string, params: Record<string, string | null | undefined>): string {
  const parsed = new URL(path, "http://localhost");
  for (const [key, value] of Object.entries(params)) {
    if (value == null) parsed.searchParams.delete(key);
    else parsed.searchParams.set(key, value);
  }
  const query = parsed.searchParams.toString();
  return `${parsed.pathname}${query ? `?${query}` : ""}${parsed.hash}`;
}
